export const NotificationsListEmpty = () => {
  return (
    <div className="flex flex-col lg:max-h-80 items-center justify-center gap-y-3 h-full">
      <p className="font-semibold text-[#222223] lg:text-lg max-w-80 text-center">
        Нет уведомлений
      </p>
      <p className="text-sm text-[#6B767F] max-w-80 lg:max-w-96 text-center lg:mt-3">
        Новые уведомления появятся здесь, как только будут новости о заказах или
        акциях
      </p>
    </div>
  );
};
